import { CustomCell } from '../../components/custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';

export const TABLE_COLUMNS = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Заказчик',
			field: 'from',
			flex: 1,
			sortable: false,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{ headerName: 'Перевозчик', field: 'to', flex: 1, sortable: false, filterOperators: getStringOperators() },
		{
			headerName: 'Договор',
			field: 'contract_number',
			flex: 1,
			sortable: false,
			filterOperators: getStringOperators(),
		},
		{
			headerName: 'Дата договора',
			field: 'contract_date',
			flex: 1,
			sortable: false,
			type: 'date',
			valueGetter: value => {
				if (!value) {
					return '';
				}

				return new Date(value);
			},
			renderCell: params => CustomCell(params),
		},
	];
};

export const getAdminTableColumns = () => {
	return [
		...TABLE_COLUMNS(),
		{ headerName: 'Условия', field: 'conditions', flex: 1, sortable: false, filterable: false },
	];
};

export const getSettingsTableColumns = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Название',
			field: 'name',
			flex: 1,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
	];
};

export const NAV_PAGE_LIST = [
	{ text: 'Мои ТЭО', href: '/companies_relationship' },
	{ text: 'Настройка ТЭО', href: '/relationship_settings' },
];

export const NAV_PAGE_LIST_CARGO = [{ text: 'Мои ТЭО', href: '/companies_relationship' }];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const ADMIN_ROLE_NUMBER = 1;
